import styled from "styled-components";
import Footer from "./components/Footer";
import SquadMaker from "./components/SquadMaker";
import TopBar from "./components/TopBar";
import React, { useEffect } from "react";
import { SquadProvider } from "./contexts/SquadContext";
import { ModalProvider } from "./contexts/ModalContext";
import { PlayerProvider } from "./contexts/PlayerContext";
import { Analytics } from "@vercel/analytics/react";
import { AuthProvider } from "./contexts/AuthContext";

const StyledContainer = styled.div`
  display: flex;
  width: 100%;
  height: 90rem;
  justify-content: center;
  align-items: center;
`;

function setMonitorScale() {
  const BASE_MONITOR_WIDTH = 1920;
  const BASE_FONT_SIZE_PX = 12;
  const currentMonitorWidth = window.screen.width;

  const scaleFactor = currentMonitorWidth / BASE_MONITOR_WIDTH;

  const newRootFontSize = BASE_FONT_SIZE_PX * scaleFactor;

  document.documentElement.style.fontSize = `${newRootFontSize}px`;
}

const StyledMain = styled.main`
  height: 100%;
`;

function App() {
  useEffect(() => {
    setMonitorScale();
    // document.title = "프로야구 스쿼드 메이커";
  }, []);

  return (
    <AuthProvider>
      <PlayerProvider>
        <SquadProvider>
          <ModalProvider>
            <StyledMain>
              <div id="modal-root"></div>
              <TopBar></TopBar>
              <StyledContainer>
                <SquadMaker></SquadMaker>
              </StyledContainer>
              <Analytics/>
              <Footer></Footer>
            </StyledMain>
          </ModalProvider>
        </SquadProvider>
      </PlayerProvider>
    </AuthProvider>
  );
}

export default App;
